export default __webpack_public_path__ + "static/MD_SearchThumb_Cloud_Sets-95a6f33f186f67cfebe7fb544b737c0e.webp";